import React, { useEffect } from 'react'

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handler = e => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowLeft') onPrev()
      if (e.key === 'ArrowRight') onNext()
    }
    window.addEventListener('keydown', handler)
    document.body.style.overflow = 'hidden'
    return () => { window.removeEventListener('keydown', handler); document.body.style.overflow = '' }
  }, [onClose, onPrev, onNext])

  return (
    <div className="lb-overlay" onClick={onClose}>
      <img src={images[index].src} alt={images[index].caption} className="lb-img" onClick={e => e.stopPropagation()}/>
      <button className="lb-btn lb-close" onClick={onClose}>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <button className="lb-btn lb-prev" onClick={e => { e.stopPropagation(); onPrev() }}>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <button className="lb-btn lb-next" onClick={e => { e.stopPropagation(); onNext() }}>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
      <div className="lb-counter">{index + 1} / {images.length}</div>
    </div>
  )
}
